/* eslint-disable no-restricted-imports */
import '@prism/styles/icon-font.min.css';
import '@prism/styles/prism.comps.min.css';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
